import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { actionTypes as authActionTypes } from "./auth.duck";

export const actionTypes = {
    SetOnboarding: "[Onboarding] Set",
    ResetOnboarding: "[Onboarding] Reset",
};

const estado_inicial = {
    passo_atual: null,
    status: null,
};

export const reducer = persistReducer(
    { storage, key: "app-onboarding", whitelist: ["passo_atual", "status"] },
    (state = estado_inicial, action) => {
        switch (action.type) {
            case actionTypes.SetOnboarding: {
                return {
                    passo_atual: action.payload?.passo_atual ?? null,
                    status: action.payload?.status ?? null,
                };
            }

            case actionTypes.ResetOnboarding:
            case authActionTypes.Logout: {
                return estado_inicial;
            }

            default:
                return state;
        }
    }
);

export const actions = {
    setOnboarding: (payload) => ({ type: actionTypes.SetOnboarding, payload }),
    resetOnboarding: () => ({ type: actionTypes.ResetOnboarding }),
};
